module.exports = __webpack_public_path__ + "static/media/loading.f252b650.gif";